module.exports = __webpack_public_path__ + "static/media/Chat_with_driver.21b41d4f.png";